import { useTheme } from '../contexts/ThemeContext'

// The store's own currency code (OMR, SAR, ...), for amounts shown in the app.
export default function CurrencyCode() {
  const { getCurrency } = useTheme()
  return getCurrency()
}
